import riot from 'riot';
import events from '../src/events.js';
riot.tag2('measurements', '<div class="container is-fluid has-text-centered" show="{parent.telemetryLoading}" style="margin-top: 5px;"> <progress class="progress is-large" max="100">60%</progress> </div> <div class="notification is-warning" if="{!parent.telemetryLoading && (!parent.telemetry || parent.telemetry.length==0)}">No Measurments for this device.</div> <div class="columns is-multiline" if="{!parent.telemetryLoading}" style="margin-top: 5px;"> <div class="column is-{showChart?\'6\':\'12\'}"> <div class="table-container"> <table class="table is-striped is-fullwidth"> <thead> <tr> <th>Method</th> <th>Activity Code</th> <th>Activity Step</th> <th>Message</th> <th>Value</th> <th>Unit</th> <th>Timestamp</th> </tr> </thead> <tbody> <tr each="{t in parent.telemetry}"> <td>{t.method}</td> <td>{t.activity_ref}</td> <td>{t.activity_step}</td> <td><span each="{d in t.data}"><span class="tag is-light">{d.msg?d.msg:d.type}</span></br> </span> </td> <td><span each="{d in t.data}"><span class="tag is-info">{d.value}</span></br> </span> </td> <td><span each="{d in t.data}"><span class="tag is-light">{d.unit}</span></br> </span> </td> <td>{epochToHumanDate(t._ts)}</td> </tr> </tbody> </table> </div> </div> <div class="column is-6" show="{showChart}"> <div class="card" each="{c in chartTypes}" style="margin-top: 5px;"> <header class="card-header"> <p class="card-header-title"> {c} Chart </p> </header> <div class="card-content"> <div class="content"> <canvas id="measurementsChart_{c}"></canvas> </div> </div> </div> </div> </div>', '', '', function(opts) {
        var self = this;
        self.showChart = true;
        self.chartTypes = []
        self.telemetry_methods = [];
        self.activity_steps = [];
        self.charts = [];

        events.on('telemetry_loaded', function(telemetry) {

            self.telemetry_methods = self.parent.telemetry.map(t => t.method);
            self.activity_steps = self.parent.telemetry.map(t => t.activity_step);

            self.telemetry_methods = [...new Set(self.telemetry_methods)];
            self.activity_steps = [...new Set(self.activity_steps)];
            try {
                self.buildCharts();
            } catch (error) {
                console.error("Error Building Charts: " + error)
            }

        });

        events.on('device_telemetry_loaded', function(telemetry) {

            self.telemetry_methods = telemetry.map(t => t.method);
            self.activity_steps = telemetry.map(t => t.activity_step);

            self.telemetry_methods = [...new Set(self.telemetry_methods)];
            self.activity_steps = [...new Set(self.activity_steps)];
            try {
                self.buildCharts();
            } catch (error) {
                console.error("Error Building Charts: " + error)
            }
        });

        this.showChartsClick = function(e) {
            self.showChart = !self.showChart;
            if (self.showChart) {
                try {
                    self.buildCharts();
                } catch (error) {
                    console.error("Error Building Charts: " + error)
                }
            } else {
                self.update();
            }
        }.bind(this)

        this.buildCharts = function() {

            if (self.charts) {
                self.charts.forEach(c => {
                    try {
                        c.destroy();
                    } catch (error) {
                        console.warn("Error destroying chart:", error);
                    }
                });

                self.charts = [];
            }

            if (self.chartTypes && self.chartTypes.length > 0) {
                self.chartTypes.forEach(chartType => {
                    var canvasId = 'measurementsChart_' + chartType;
                    var existingChart = Chart.getChart(canvasId);
                    if (existingChart) {
                        try {
                            existingChart.destroy();
                        } catch (error) {
                            console.warn("Error destroying existing chart for canvas " + canvasId + ":", error);
                        }
                    }
                });
            }

            var telemetry = self.parent.telemetry;
            if (!telemetry) {
                console.log("No Telemetry Data...cannot build charts");
                return;
            }
            self.chartTypes = [];
            for (var i = 0; i < telemetry.length; i++) {
                if (!telemetry[i] || !telemetry[i].data) continue;
                telemetry[i].data.forEach(d => {

                    if (isNaN(d.value) || typeof d.value === 'boolean') return;
                    if (self.chartTypes.includes(d.type) == false) {
                        self.chartTypes.push(d.type)
                    }
                });
            }

            self.update();

            for (var i = 0; i < self.chartTypes.length; i++) {
                var cLabels = []
                var cDatasets = []
                for (var j = 0; j < telemetry.length; j++) {
                    if (!telemetry[j] || !telemetry[j].data) continue;
                    telemetry[j].data.forEach(d => {
                        if (d.type != self.chartTypes[i]) return;
                        cLabels.push(self.epochToHumanDate(telemetry[j]._ts));
                        if (!cDatasets.find(ds => ds.label == (d.type + " (" + d.unit + ")"))) {
                            cDatasets.push({
                                label: d.type + " (" + d.unit + ")",
                                data: [d.value],
                                fill: false,
                                borderColor: randomColor(),
                                tension: 0.1
                            });
                        } else {
                            cDatasets.find(ds => ds.label == (d.type + " (" + d.unit + ")")).data.push(d.value);
                        }
                    });
                }

                var canvasId = 'measurementsChart_' + self.chartTypes[i];
                var ctx = document.getElementById(canvasId);

                if (!ctx) {
                    console.warn("Canvas element not found for ID:", canvasId);
                    continue;
                }

                var existingChart = Chart.getChart(canvasId);
                if (existingChart) {
                    try {
                        existingChart.destroy();
                    } catch (error) {
                        console.warn("Error destroying existing chart before creation:", error);
                    }
                }

                try {
                    var myChart = new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: cLabels,
                            datasets: cDatasets
                        }
                    });

                    self.charts.push(myChart);

                } catch (error) {
                    console.error("Error creating chart for canvas " + canvasId + ":", error);
                }
            }

            self.showChart = true;
            self.update();
        }.bind(this)

        function randomColor() {
            return 'rgb(' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ',' + Math.floor(Math.random() * 256) + ')';
        }

        this.refreshClick = function(e) {

        }.bind(this)

        this.prettyValue = function(v) {

            if (v === 0) {
                return 0;
            } else if (!isNaN(v)) {

                return v.toFixed(2);
            } else {
                return v
            }
        }.bind(this)

        this.prettyMethodName = function(n) {

            if (n == "photoresistor" || n == "light" || n == "light_pr") {
                return "Light"
            } else if (n == "gas_mq" || n == "mq2") {
                return "Gas"
            } else if (n == "dht11") {
                return "Temp/Humidity"
            } else if (n == "soil_moisture") {
                return "Soil Moisture"
            } else if (n == "sound") {
                return "Sound"
            } else if (n == "flame") {
                return "Flame"
            } else if (n == "hall") {
                return "Magnetic Field"
            } else {
                return n[0].toUpperCase() + n.substring(1)
            }

        }.bind(this)

        this.sortTelemetryByStep = function(telemetry) {

            if (telemetry) {
                return telemetry.sort((firstItem, secondItem) => firstItem.activity_step - secondItem.activity_step);
            } else {
                return telemetry;
            }
        }.bind(this)

        this.epochToHumanDate = function(epoch) {
            var d = new Date(0);
            d.setUTCSeconds(epoch);

            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        }.bind(this)

        this.on('unmount', function() {
            if (self.charts && self.charts.length > 0) {
                console.log("Cleaning up charts on measurements component unmount");
                self.charts.forEach(c => {
                    try {
                        c.destroy();
                    } catch (error) {
                        console.warn("Error destroying chart on unmount:", error);
                    }
                });
                self.charts = [];
            }
        });
});


